import { render, staticRenderFns } from "./SystemModuleSideMenu.vue?vue&type=template&id=fb2c3878"
import script from "./SystemModuleSideMenu.vue?vue&type=script&lang=js"
export * from "./SystemModuleSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2c3878')) {
      api.createRecord('fb2c3878', component.options)
    } else {
      api.reload('fb2c3878', component.options)
    }
    module.hot.accept("./SystemModuleSideMenu.vue?vue&type=template&id=fb2c3878", function () {
      api.rerender('fb2c3878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/systemmodule/SystemModuleSideMenu.vue"
export default component.exports